var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.99 15.5758V10.1223C73.99 6.25842 70.8449 3.11415 66.98 3.11415H34.175L32.9505 1.11498C32.525 0.422227 31.7719 -0.00164795 30.9572 -0.00164795H7.00998C3.14508 -6.6326e-05 0 3.1442 0 7.00811V66.1845C0 70.0484 3.14508 73.1927 7.00998 73.1927H73.99C77.8549 73.1927 81 70.0484 81 66.1845V22.5823C81 18.7184 77.8549 15.5742 73.99 15.5742V15.5758ZM66.98 7.78626C68.2678 7.78626 69.3167 8.83488 69.3167 10.1223V15.5726H41.8068L38.6791 10.4671L37.0369 7.78626H66.98ZM76.3267 66.1845C76.3267 67.472 75.2778 68.5206 73.99 68.5206H7.00998C5.72221 68.5206 4.67332 67.472 4.67332 66.1845V7.00811C4.67332 5.72066 5.72221 4.67205 7.00998 4.67205H29.6504L30.8749 6.66964L35.379 14.0226L38.5082 19.1297C38.9338 19.8224 39.6868 20.2463 40.5016 20.2463H73.9916C75.2794 20.2463 76.3283 21.2949 76.3283 22.5823V66.1845H76.3267Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.14707557.svg";
export { ForwardRef as ReactComponent };